import { App, Button, Col, Form, Modal, Row, Space } from "antd";
import FormInput from "component/form/form_input";
import FormInputNumber from "component/form/form_input_number";
import { useActionDraftSpeaker } from "hook/draft/dialog/useActionDraftSpeaker";
import React from "react";
import { useSearchParams } from "react-router-dom";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogSpeakerAdd = () => {
  // -------------------------- VAR -----------------------------
  const { handleAddSpeaker } = useActionDraftSpeaker();
  const { message } = App?.useApp();
  const [form] = Form?.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "not_edit";
  const openView = searchParams.get("viewSpeakerAdd") === "true";
  const open = tab === "merged" && openView;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const onCancel = () => {
    setSearchParams({ tab });
  };

  const handleSave = () => {
    form
      ?.validateFields()
      .then((values) => {
        if (!values) return message.warning("Dữ liệu lỗi");
        const { from, to, speaker } = values;
        const label = speaker;
        const object = { from, to, label, delete: true };
        return handleAddSpeaker(object, form);
      })
      .catch((err) => {
        console.log({ err });
      });
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      centered
      onCancel={onCancel}
      title="Tạo Speaker mới"
      footer={null}
      open={open}
    >
      <Form layout="vertical" form={form} id="form-speaker-add">
        <Row className="mt-5">
          <Col xl={24} lg={24} md={24} xs={24}>
            <div className="flex flex-row gap-4">
              <FormInputNumber
                addonAfter="số giây"
                label="Voice mẫu (Bắt đầu)"
                name="from"
                initvalue={0}
                rules={[{ required: true, message: "Vui lòng không để trống" }]}
              />
              <FormInputNumber
                addonAfter="số giây"
                label="Voice mẫu (Kết thúc)"
                name="to"
                initvalue={0}
                rules={[{ required: true, message: "Vui lòng không để trống" }]}
              />
            </div>
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <FormInput
              label="Speaker"
              name="speaker"
              initvalue={0}
              placeholder="Nhập tên Speaker"
              rules={[{ required: true, message: "Vui lòng không để trống" }]}
            />
          </Col>
          <Col align="right" xl={24} lg={24} md={24} xs={24}>
            <Space>
              <Button onClick={onCancel}>Huỷ</Button>
              <Button type="primary" onClick={handleSave}>
                Lưu
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
export default DialogSpeakerAdd;
